export const validateEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validatePassword = (password: string): boolean => {
  return password.length >= 8;
};

export const validateDisplayName = (name: string): boolean => {
  return name.length >= 3 && name.length <= 50;
};

export const validateProvinceName = (name: string): boolean => {
  return name.length >= 3 && name.length <= 25;
};

export const validateRulerName = (name: string): boolean => {
  return name.length >= 3 && name.length <= 25;
};
